// extracted by mini-css-extract-plugin
export default {"wrapper_content":"styles_wrapper_content__RBgrL","wrapper":"styles_wrapper__x26T2","text_header":"styles_text_header__eRQht","text":"styles_text__Endvq"};